export const SUPPORTED_LANGUAGES = ['javascript', 'typescript'] as const
